import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {ProfileService} from '../profile.service';

@Component({
    selector: 'main-profile-change-language',
    template: require('./profile-change-language.component.html'),
    providers: [ProfileService]
})

export class MainProfileChangeLanguageComponent implements OnInit {
                
    @Input('language') userLanguage: string;
    @Output('languageUpdated') languageUpdated = new EventEmitter();    
    
    constructor(private _profileService: ProfileService) {
        
    }

    ngOnInit() {
        
    }        

   changeLanguage(lang: number) {              
       this.languageUpdated.emit({
             value: lang
        });
   }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/profile/profile_change_language/profile-change-language.component.ts
 **/